import React from "react";
import { Link } from "react-router-dom";
import { FeedbackAutocompleteItem } from "../../../../Layout/Models/AutocompleteItem";
import { appPaths } from "../../../../Common";
import { feedbackService } from "../../../Services";

type Props = {
  query: string;
  items: FeedbackAutocompleteItem[];
};

export default class SimilarFeedbackSuggestions extends React.Component<Props> {
  render() {
    if (this.props.items.length > 0) {
      return (
        <div>
          <p>
            We found some feedback with similar titles, is your feedback a duplicate of one of
            these?
          </p>
          <ul>
            {this.props.items.map((el: FeedbackAutocompleteItem, index: number) => {
              return (
                <li>
                  <Link to={feedbackService.getAutocompleteViewUrl(el)} target="_blank">
                    {el.itemName}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      );
    }

    return null;
  }
}
